module.exports = __webpack_public_path__ + "img/carousel-image-1.829e6375.png";